export enum EPlayerActivityCheckerActions {
  checkPlayerActivity = 'checkPlayerActivity'
}
